export const TOKEN_CURRENT = 'TOKEN_CURRENT'
export const ROLE_ID = 'ROLE_ID'
export const USER_DATA = 'USER_DATA'

export const _ = undefined
